/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const usePgHbaListStyles = makeStyles(() => ({
  root: {
    maxWidth: '864px',
  },
  buttons: {
    maxWidth: '840px',
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  controlButton: {
    minWidth: '120px',
    marginLeft: '10px',
    padding: '13px 0',
    '&:first-child': {
      marginLeft: 0,
    },
  },
}));
